import { memo, useMemo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { uniqBy } from "@common/helpers/collections";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceMembersRow } from "../workspaceMembersRow";
import styles from "../WorkspaceMembers.module.scss";

export const EntitiesCell = memo(function EntitiesCell({
    row,
}: CellContext<ViewTableFeatures, WorkspaceMembersRow, unknown>) {
    const data = row.original;

    const entities = useMemo(() => {
        if (data.kind === "member") {
            return data.member.entityAssignments.map((a) => a.entity);
        }
        if (data.kind === "organization") {
            return uniqBy(
                data.organizationMembers.flatMap((m) =>
                    m.entityAssignments.map((a) => a.entity),
                ),
                (e) => e.id,
            );
        }
        if (data.kind === "invite") {
            return (
                data.invite.entityAssignments?.map((item) => item.entity) ?? []
            );
        }
        return [];
    }, [data]);

    return (
        <ViewTableCell>
            <span className={styles.list}>
                <EntityAvatarGroup entities={entities} max={3} size="xs" />
            </span>
        </ViewTableCell>
    );
});
